import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { open as openInterstitialAction } from '../../../slices/interstitialSlice'
import TaskItem from '../TaskItem'
import { selectAllFields, selectCompletedFields } from '../../../slices/formInstanceSlice'

export default function FieldsTask({ disabled = false }) {
  const dispatch = useDispatch()
  const openInterstitial = useCallback(() => dispatch(openInterstitialAction()), [dispatch])
  const numberCompletedFields = useSelector(selectCompletedFields).length
  const allFields = useSelector(selectAllFields)
  const numberAllFields = useMemo(() => Object.keys(allFields)?.length, [allFields])

  return (
    <TaskItem
      disabled={disabled}
      title="fields"
      subTitle={
        numberCompletedFields === 0 && numberAllFields === 0 ? '...' : `${numberCompletedFields} / ${numberAllFields}`
      }
      btnTitle="open"
      iconClassName="fa-light fa-pen-field"
      onSubmit={openInterstitial}
    />
  )
}
